/**
 * The /compare route is embedded in the Roland Cloud Manager desktop app as a
 * webview, where a cookie banner is both meaningless and actively harmful: RCM
 * sizes the webview to the page height, so OneTrust's overlay lands far below
 * the fold and the user only sees an unexplained dark screen.
 *
 * The route therefore loads no trackers at all — no OneTrust, GTM, CrazyEgg,
 * Adobe Launch, GA4, Amplitude or Datadog RUM. That is what makes suppressing
 * the banner legitimate rather than a workaround: with nothing to consent to,
 * there is no consent to collect. Do not load a tracker here without putting
 * the banner back.
 *
 * public/index.html repeats this test inline, before any script runs. Keep the
 * two in sync.
 */
export const isEmbedRoute = () => /\/compare\/?$/.test(window.location.pathname);
